import React, { useState } from "react";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, AppBar, Toolbar, Typography, IconButton, Box, CssBaseline } from "@mui/material";
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  Menu as MenuIcon,
  ChevronLeft as ChevronLeftIcon,
} from "@mui/icons-material";
import { Link, Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./Dashboard";
import ApplicationFormReport from "./ApplicationFormReport";

const drawerWidth = 240;

const AdminPanel = () => {
  const [open, setOpen] = useState(true);
  const location = useLocation(); // Get current route

  // Sidebar Menu Items
  const menuItems = [
    { key: "dashboard", icon: <DashboardIcon />, label: "Dashboard", path: "/admin" },
    { key: "applicationformreport", icon: <PeopleIcon />, label: "Application Form Report", path: "/admin/applicationformreport" },
  ];

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      {/* App Bar (Header) */}
      <AppBar position="fixed" sx={{ width: open ? `calc(100% - ${drawerWidth}px)` : "100%", ml: open ? `${drawerWidth}px` : "0", transition: "width 0.3s" }}>
        <Toolbar>
          <IconButton color="inherit" aria-label="open drawer" onClick={() => setOpen(!open)} edge="start" sx={{ mr: 2 }}>
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
          <Typography variant="h6" noWrap component="div">
            {menuItems.find((item) => location.pathname.includes(item.path))?.label || "Dashboard"}
          </Typography>
        </Toolbar>
      </AppBar>

      {/* Sidebar */}
      <Drawer variant="permanent" open={open} sx={{
        width: open ? drawerWidth : 60,
        flexShrink: 0,
        transition: "width 0.3s",
        [`& .MuiDrawer-paper`]: { width: open ? drawerWidth : 60, boxSizing: "border-box" }
      }}>
        <Toolbar />
        <List>
          {menuItems.map((item) => (
            <ListItemButton key={item.key} component={Link} to={item.path} sx={{ display: "flex", gap: 1 }}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              {open && <ListItemText primary={item.label} />}
            </ListItemButton>
          ))}
        </List>
      </Drawer>

      {/* Content Area */}
      <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8, background: "#f8f9fa", minHeight: "100vh" }}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/applicationformreport" element={<ApplicationFormReport />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default AdminPanel;
